import { PureComponent } from 'react';

import './BlackFridayScrollTop.style';

export class BlackFridayScrollTop extends PureComponent {
    render() {
        const { active } = this.props;

        if (!active) {
            return null;
        }

        return (
            <div block="BlackFridayScrollTop" onClick={ () => window.scrollTo({ top: 0, behavior: 'smooth' }) }>
                <svg xmlns="http://www.w3.org/2000/svg" width="28.559" height="34.271" viewBox="0 0 28.559 34.271"><path d="M15.707 32.843V4.356l10.39 10.908a1.428 1.428 0 0 0 2.068-1.97L16.299.837a2.855 2.855 0 0 0-4.063.025L.394 13.295a1.428 1.428 0 1 0 2.068 1.97L12.851 4.311v28.532a1.428 1.428 0 0 0 2.856 0Z" fill="#fff"/></svg>
            </div>
        );
    }
}

export default BlackFridayScrollTop;
